import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useApolloClient } from "@apollo/client";
import StatBox from "components/StatBox";
import ModalUtil from "components/ModalUtil";
import { Email, PointOfSale } from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import StatBoxOne from "components/StatBoxOne";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import { DataGrid,   GridToolbarContainer,esES,
  GridToolbarFilterButton,
  GridToolbarDensitySelector, } from "@mui/x-data-grid";
import CreateCisternPreUso from "./CreateCisternPreUso";
import {
  GET_PREUSE_COMPONENT_CISTERN,
  GET_PREUSE_CISTERN,
  GET_MAIN_DATA,
} from "./QueryCistern";
import { GET_ALL_PERSONAL } from "./../../gestionpersonal/FichaPersonal/QueryPersonal";
import { GET_DECLARATION } from "./../van/QueryVan";
import ViewCistern from "./ViewCistern";
import ViewPdf from "components/ViewPdf";
import PDFCistern from "./PDFCistern";
import {GET_ALL_DRIVER} from "./../../operation/operation/QueryOperation"
const Cistern = () => {
  const client = useApolloClient();
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const [question, setQuestion] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [declaration, setDeclaration] = useState([]);
  const [id, setId] = useState(null);
  const [newCisternPreUse, setNewCisternPreUse] = useState([]);
  const [modalOpenView, setModalOpenView] = useState(false);
  const [cisternPreUse, setCisternPreUse] = useState([]);
  const [modalOpenPDF, setModalOpenPDF] = useState(false);
  const [alertCustom, setAlertCustom] = useState({
    type: "success",
    message: "",
    state: false,
  });
  const handleOpenModalView = (id) => {
    setModalOpenView(true);
    setId(id);
  };

  const handleCloseModalView = () => {
    setModalOpenView(false);
  };
  const handleOpenModalPDF = (id) => {
    setModalOpenPDF(true);
    setId(id);
  };

  const handleCloseModalPDF = () => {
    setModalOpenPDF(false);
  };
  const columns = [
    {
      field: "N",
      headerName: "#",
      with: "5px",
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1,
    },
    {
      field: "activity",
      headerName: "ACTIVIDAD",
      flex: 1,
      renderCell: (params) => params.row.activity,
    },
    {
      field: "date",
      headerName: "FECHA",
      flex: 1,
      renderCell: (params) =>
        new Date(params.row.date).toLocaleDateString("es-ES"),
    },
    {
      field: "capacity",
      headerName: "CAPACIDAD",
      flex: 1,
      renderCell: (params) => params.row.capacity,
    },
    {
      field: "ope",
      headerName: "",
      renderCell: (params) => (
        <Box display={"flex"} gap={"5px"}>
          <VisibilityIcon onClick={() => handleOpenModalView(params.row.id)} />
          <LocalPrintshopIcon
            onClick={() => handleOpenModalPDF(params.row.id)}
          />
          {/*  <CreateIcon />
          <DeleteIcon /> */}
        </Box>
      ),
    },
  ];
  useEffect(() => {
    const FUNCTION_GET_ALL_PERSONAL = async () => {
      try {
        const { data } = await client.query({
          query: GET_ALL_PERSONAL,
        });
        setPersonal(data.getAllPersonal);
      } catch (error) {
        console.log(error.message);
      }
   /*    try {
        const { data } = await client.query({
          query: GET_ALL_DRIVER,
          fetchPolicy: "network-only",
        });
        console.log(data.getAllDriver);
        setPersonal(data.getAllDriver);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      } */
    };
    const FUNCTION_GET_DECLARATION = async () => {
      try {
        const { data } = await client.query({
          query: GET_DECLARATION,
          fetchPolicy: "network-only",
        });
        setDeclaration(data.getDeclaration);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    const FUNCTION_GET_PRE_USE_COMPONENT = async () => {
      try {
        const { data } = await client.query({
          query: GET_PREUSE_COMPONENT_CISTERN,
          fetchPolicy: "network-only",
        });
        setQuestion(data.getPreUseComponenCistern);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };

    const FUNCTION_GET_PREUSE_CISTERN = async () => {
      try {
        const { data } = await client.query({
          query: GET_PREUSE_CISTERN,
          fetchPolicy: "network-only",
        });
        setCisternPreUse(data.getPreUseCistern);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };

    const FUNCTION_MAIN_DATA = async () => {
      try {
        const { data } = await client.query({
          query: GET_MAIN_DATA,
          fetchPolicy: "network-only",
        });
        setMainData(data.getSumarizeCistern);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    FUNCTION_MAIN_DATA();
    FUNCTION_GET_PREUSE_CISTERN();
    FUNCTION_GET_PRE_USE_COMPONENT();
    FUNCTION_GET_ALL_PERSONAL();
    FUNCTION_GET_DECLARATION();
  }, [newCisternPreUse]);
  return (
    <>
      <ModalUtil
        isOpen={modalOpenView}
        onClose={handleCloseModalView}
        Component={ViewCistern}
        sizewidth={900}
        params={
          new Object({
            setAlertCustom: setAlertCustom,
            alertCustom: alertCustom,
            setNewAssignRequeriment: null,
            handleCloseModal: handleCloseModalView,
          })
        }
        id={id}
      ></ModalUtil>{" "}
      <ModalUtil
        isOpen={modalOpenPDF}
        onClose={handleCloseModalPDF}
        Component={ViewPdf}
        params={
          new Object({
            setAlertCustom: setAlertCustom,
            alertCustom: alertCustom,
            setNewAssignRequeriment: null,
            handleCloseModal: handleCloseModalPDF,
            Component: PDFCistern,
            title: "Cisterna",
          })
        }
        id={id}
      ></ModalUtil>
      <Box m="1.5rem 2.5rem">
        <FlexBetween>
          <Header
            title="SEGURIDAD"
            subtitle="seguridad/checklist pre uso cisterna"
          />
        </FlexBetween>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="160px"
          gap="20px"
          sx={{
            "& > div": {
              gridColumn: isNonMediumScreens ? undefined : "span 12",
            },
          }}
        >
          <StatBoxOne
            title="Total registros"
            value={mainData?.amount}
            /*   increase={mainData?.cargo}*/
            description={"Cantidad de registros de Cisterna"}
            icon={
              <Email
                sx={{ color: theme.palette.secondary[300], fontSize: "26px" }}
              />
            }
          />
          <StatBoxOne
            title="Actividad"
            value={mainData?.lastsubject}
            /*   increase={mainData?.cargo} */
            description={"Ultimo registros de Cisternas"}
            icon={
              <Email
                sx={{ color: theme.palette.secondary[300], fontSize: "26px" }}
              />
            }
          />
          {/* <StatBoxOne
        
          />
          <StatBoxOne
         
          /> */}
          {/* ROW 1 */}

          {/* ROW 2 */}

          <Box
            gridColumn="span 12"
            gridRow="span 9"
            backgroundColor={theme.palette.background.alt}
            p="1rem"
            borderRadius="0.55rem"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
                borderRadius: "5rem",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: theme.palette.background.alt,
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderTop: "none",
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${theme.palette.secondary[200]} !important`,
              },
            }}
          >
            <CreateCisternPreUso
              alertCustom={alertCustom}
              setAlertCustom={setAlertCustom}
              question={question}
              personal={personal}
              declaration={declaration}
              setNewCisternPreUse={setNewCisternPreUse}
            />
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 3"
            backgroundColor={theme.palette.background.alt}
            p="1rem"
            borderRadius="0.55rem"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
                borderRadius: "5rem",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: theme.palette.background.alt,
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderTop: "none",
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${theme.palette.secondary[200]} !important`,
              },
            }}
          >
            <DataGrid
              loading={!cisternPreUse}
              getRowId={(row) => row.id}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}  
              rows={cisternPreUse || []}
              columns={columns}
              components={{
                Toolbar: () => <GridToolbarContainer>
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
              </GridToolbarContainer>,
              }}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Cistern;
